<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Listado de precios</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <v-layout>
                            <v-flex xs12 sm2>
                                <v-autocomplete clearable label="Tipo de producto" v-model="d.item_tipos_id" :items="item_tipos" item-value="id" item-text="desig" @change="itemTipoChange()"></v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm4 v-if="d.item_tipos_id !== 5">
                                <item-select v-model="item" :id.sync="d.item_id" :tipo="d.item_tipos_id" @change="tabla()"></item-select>
                            </v-flex>
                            <v-flex xs12 sm3 v-if="d.item_tipos_id === 5">
                                <v-text-field label="Código del panel" v-model="codigo" @change="decodifica()"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <v-data-table
                                        :headers="headers"
                                        :items="items"
                                        :pagination.sync="pag"
                                        :total-items="totalItems"
                                        :loading="loading"
                                        rows-per-page-text="Filas por pagina"
                                        no-data-text="No hay datos"
                                        disable-initial-sort
                                        item-key="id"
                                        class="tabla-compacta-col"
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr @click="props.selected = !props.selected" @dblclick="props.expanded = !props.expanded">
                                            <td class="text-xs-center">{{ props.item.item_tipo }}</td>
                                            <td class="text-xs-left">{{ props.item.codigo }}</td>
                                            <td class="text-xs-left">{{ props.item.descripcion }}</td>
                                            <td class="text-xs-left">{{ props.item.um }}</td>
                                            <td class="text-xs-right"><b>{{ (props.item.valor)?props.item.valor : 0 | moneda(2) }}</b></td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import moneda from '../../filters/moneda';
    import mixinPrecio from '../../mixins/precios';
    import mixinConfig from '../../mixins/config';
    import {mapActions} from 'vuex';
    import itemSelect from '../../components/ItemSelect';
    import saveAs from 'file-saver';

    function initialData() {
        return {
            item_tipos_id: '',
            item_id: '',
            tipo_panel: '',
            nucleo: '',
            esp: '',
            densidad: '',
            ext_esp: '',
            ext_rev: '',
            int_esp: '',
            int_rev: '',
            valor: 0,
        }
    }

    export default {
        name: "listado",
        filters: {moneda},
        mixins: [mixinPrecio, mixinConfig],
        components: {itemSelect},
        data() {
            return {
                porcent: {
                    desc: '',
                    valor: ''
                },
                item: {},
                d: initialData(),
                headers: [
                    {text: 'Tipo Item', value: 'item_tipos_id', align: 'center'},
                    {text: 'Cód', value: 'item_id', align: 'center'},
                    {text: 'Item', value: 'items.descripcion', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Valor', value: 'valor', align: 'center'},
                ],
                loading: false,
                pag: {},
                totalItems: 0,
                tipo_panel: [],
                item_tipos: [],
                nucleo: [],
                esp: [],
                densidad: [],
                cara_esp: [],
                cara_rev: [],
                items: [],
                precioNuevo: '',
                posiciones: [],
                codigo: ''
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            this.datos();
            this.codigos();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
            codigos() {
                this.$http.post("panel/listado")
                    .then(r => {
                        this.posiciones = r.data.posiciones.pan;
                    });
            },
            decodifica() {
                if (this.codigo.length < 2) {
                    return false;
                }
                let cod = this.codigo.toUpperCase();

                this.posiciones.forEach(r => {
                    let valor = cod.substring(r.desde, r.desde + r.cant);
                    if (r.seccion === 'tipo') {
                        this.d.tipo_panel = valor;
                    } else if (r.seccion === 'nucleo') {
                        this.d.nucleo = valor;
                    } else if (r.seccion === 'esp') {
                        this.d.esp = valor;
                    } else if (r.seccion === 'ext_esp') {
                        this.d.ext_esp = valor;
                    } else if (r.seccion === 'ext_rev') {
                        this.d.ext_rev = valor;
                    } else if (r.seccion === 'int_esp') {
                        this.d.int_esp = valor;
                    } else if (r.seccion === 'int_rev') {
                        this.d.int_rev = valor;
                    } else if (r.seccion === 'dens') {
                        this.d.densidad = valor;
                    }
                });
                this.tabla();
            },
            datos() {
                this.precioDatos(r => {
                    this.tipo_panel = r.tipo_panel;
                    this.item_tipos = r.item_tipos;
                }, err => {
                    console.log(err);
                });
            },
            itemTipoChange() {
                let tipo_id = this.d.item_tipos_id;
                this.d = initialData();
                this.d.item_tipos_id = tipo_id;
                this.tabla();
            },
            tabla() {
                this.loading = true;
                this.pag.filtros = this.d;
                this.precioIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/presup/precios.vue